export default "__VITE_ASSET__Buf3POaK__"